import { render, staticRenderFns } from "./regularization.vue?vue&type=template&id=778b651d&scoped=true"
import script from "./regularization.vue?vue&type=script&lang=js"
export * from "./regularization.vue?vue&type=script&lang=js"
import style0 from "./regularization.vue?vue&type=style&index=0&id=778b651d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "778b651d",
  null
  
)

export default component.exports